import { Box } from '@chakra-ui/react'

import { useAppSelector } from '@/redux/hooks'
import { selectFullName, selectRoles } from '@/redux/me/meSlice'
import {
  getIndefiniteArticle,
  removeUnderscoreAndCapitalize,
} from '@/utils/formats'

export const AccountInformationHeader = () => {
  const fullName = useAppSelector(selectFullName)
  const roles = useAppSelector(selectRoles)
  const displayRoles = roles
    .map((role) => removeUnderscoreAndCapitalize(role))
    .filter(Boolean)

  return (
    <Box my='6'>
      <Box fontSize='48px' fontWeight='extrabold' letterSpacing='-1.6px'>
        {`Welcome, ${fullName}`}
      </Box>
      <Box fontSize='14px' letterSpacing='-0.47px'>
        {displayRoles.length === 1 ? (
          <>
            You are signed in as {getIndefiniteArticle(displayRoles[0])}{' '}
            <Box as='span' fontWeight='bold'>
              {displayRoles[0]}
            </Box>
          </>
        ) : displayRoles.length > 1 ? (
          <>
            Your roles:{' '}
            <Box as='span' fontWeight='bold'>
              {displayRoles.join(', ')}
            </Box>
          </>
        ) : (
          'You are signed in'
        )}
      </Box>
    </Box>
  )
}
